import React, { useEffect } from 'react';

import './cookieConsent.css';
// @ts-ignore - ported vanilla JS banner logic (shared with programylojalnosciowe.pl)
import { initCookieConsent } from './cookieConsentInit.js';

const PRIVACY_URL = '/polityka-prywatnosci/';

const CookieIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="8" cy="9" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="14" cy="7" r="1" fill="currentColor" stroke="none" />
    <circle cx="16" cy="12" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="10" cy="14" r="1" fill="currentColor" stroke="none" />
    <circle cx="13" cy="16" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);

const CookieConsent = () => {
  useEffect(() => {
    initCookieConsent();
  }, []);

  return (
    <>
      <div
        id="vsc-cookie-consent"
        className="vsc-cookie-consent"
        role="dialog"
        aria-label="Ustawienia plików cookie"
        aria-hidden="true"
      >
        <div className="vsc-cookie-consent__inner">
          {/* Header */}
          <div className="vsc-cookie-consent__header">
            <CookieIcon />
            <span>Cookies</span>
          </div>

          {/* Tab bar */}
          <div className="vsc-cookie-consent__tabs" role="tablist">
            <button
              className="vsc-cookie-consent__tab vsc-cookie-consent__tab--active"
              data-tab="consent"
              role="tab"
              aria-selected="true"
              type="button"
            >
              Zgoda
            </button>
            <button
              className="vsc-cookie-consent__tab"
              data-tab="details"
              role="tab"
              aria-selected="false"
              type="button"
            >
              Szczegóły
            </button>
            <button
              className="vsc-cookie-consent__tab"
              data-tab="about"
              role="tab"
              aria-selected="false"
              type="button"
            >
              O plikach cookies
            </button>
          </div>

          {/* Consent panel */}
          <div
            id="vsc-tab-consent"
            className="vsc-cookie-consent__panel vsc-cookie-consent__panel--active"
            role="tabpanel"
            aria-hidden="false"
          >
            <div className="vsc-cookie-consent__panel-body">
              <p>
                Ta strona korzysta z plików cookie, aby zapewnić najlepszą jakość usług. Pliki cookie
                pozwalają nam analizować ruch na stronie i dostosowywać treści do Twoich potrzeb.
              </p>
              <p>
                Możesz zaakceptować wszystkie pliki cookie, odrzucić opcjonalne lub dostosować swoje
                preferencje w zakładce „Szczegóły”. <a href={PRIVACY_URL}>Polityka prywatności</a>.
              </p>
              <p
                className="vsc-cookie-consent__gpc-notice"
                id="vsc-gpc-notice"
                style={{ display: 'none' }}
              >
                Wykryliśmy sygnał Global Privacy Control (GPC) w Twojej przeglądarce. Opcjonalne pliki
                cookie zostały automatycznie wyłączone.
              </p>
            </div>
          </div>

          {/* Details panel */}
          <div id="vsc-tab-details" className="vsc-cookie-consent__panel" role="tabpanel" aria-hidden="true">
            <div className="vsc-cookie-consent__panel-body">
              {/* Necessary */}
              <div className="vsc-cookie-consent__category">
                <div className="vsc-cookie-consent__category-header">
                  <div className="vsc-cookie-consent__category-info">
                    <strong>Niezbędne</strong>
                    <span className="vsc-cookie-consent__always-on">Zawsze aktywne</span>
                  </div>
                  <label className="vsc-cookie-toggle vsc-cookie-toggle--disabled">
                    <input type="checkbox" defaultChecked disabled />
                    <span className="vsc-cookie-toggle__slider"></span>
                  </label>
                </div>
                <p className="vsc-cookie-consent__category-desc">
                  Niezbędne pliki cookie umożliwiają podstawowe funkcje strony, takie jak nawigacja i
                  dostęp do zabezpieczonych obszarów. Strona nie może prawidłowo funkcjonować bez tych
                  plików cookie.
                </p>
              </div>

              {/* Statistics */}
              <div className="vsc-cookie-consent__category">
                <div className="vsc-cookie-consent__category-header">
                  <div className="vsc-cookie-consent__category-info">
                    <strong>Statystyka</strong>
                  </div>
                  <label className="vsc-cookie-toggle">
                    <input type="checkbox" id="vsc-toggle-statistics" />
                    <span className="vsc-cookie-toggle__slider"></span>
                  </label>
                </div>
                <p className="vsc-cookie-consent__category-desc">
                  Statystyczne pliki cookie pomagają nam zrozumieć, w jaki sposób odwiedzający korzystają
                  ze strony, zbierając i raportując informacje anonimowo (Google Analytics, Google Tag
                  Manager).
                </p>
              </div>

              {/* Marketing */}
              <div className="vsc-cookie-consent__category">
                <div className="vsc-cookie-consent__category-header">
                  <div className="vsc-cookie-consent__category-info">
                    <strong>Marketing</strong>
                  </div>
                  <label className="vsc-cookie-toggle">
                    <input type="checkbox" id="vsc-toggle-marketing" />
                    <span className="vsc-cookie-toggle__slider"></span>
                  </label>
                </div>
                <p className="vsc-cookie-consent__category-desc">
                  Marketingowe pliki cookie służą do śledzenia odwiedzających na stronach internetowych w
                  celu wyświetlania reklam dopasowanych do zainteresowań użytkownika.
                </p>
              </div>
            </div>
          </div>

          {/* About panel */}
          <div id="vsc-tab-about" className="vsc-cookie-consent__panel" role="tabpanel" aria-hidden="true">
            <div className="vsc-cookie-consent__panel-body">
              <p>
                Pliki cookie to małe pliki tekstowe, które są umieszczane na Twoim urządzeniu podczas
                odwiedzania stron internetowych. Są powszechnie stosowane, aby strony internetowe działały
                prawidłowo i wydajniej, a także aby dostarczać informacje właścicielom stron.
              </p>
              <p>
                Zgodnie z Rozporządzeniem o Ochronie Danych Osobowych (RODO) oraz Prawem Komunikacji
                Elektronicznej (PKE), wymagamy Twojej zgody na stosowanie opcjonalnych plików cookie.
              </p>
              <p>
                Więcej informacji znajdziesz w naszej <a href={PRIVACY_URL}>Polityce prywatności</a>.
              </p>
            </div>
          </div>

          {/* Action buttons */}
          <div className="vsc-cookie-consent__actions">
            <button className="vsc-cookie-btn vsc-cookie-btn--reject" type="button">
              Odmowa
            </button>
            <button
              className="vsc-cookie-btn vsc-cookie-btn--confirm"
              id="vsc-cookie-confirm-selected"
              type="button"
            >
              Potwierdź wybrane
            </button>
            <button className="vsc-cookie-btn vsc-cookie-btn--accept-all" type="button">
              Zaakceptuj wszystkie
            </button>
          </div>
        </div>
      </div>

      {/* Floating settings button */}
      <button
        id="vsc-cookie-settings-btn"
        className="vsc-cookie-settings-btn"
        type="button"
        aria-label="Ustawienia plików cookie"
      >
        <CookieIcon />
      </button>
    </>
  );
};

export default CookieConsent;
